/* NSCREATION - vitrine produits : fleches, glisser a la souris, ajout rapide au panier coulissant */
(function () {
  if (customElements.get('nsc-showcase')) return;

  class NscShowcase extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.nsc-sc__list');
      this.prev = this.querySelector('[data-nsc-sc-dir="-1"]');
      this.next = this.querySelector('[data-nsc-sc-dir="1"]');

      var self = this;
      this.addEventListener('click', function (event) {
        var arrow = event.target.closest('[data-nsc-sc-dir]');
        if (arrow) {
          self.scrollStep(parseInt(arrow.getAttribute('data-nsc-sc-dir'), 10));
          return;
        }
        var add = event.target.closest('[data-nsc-sc-add]');
        if (add) self.quickAdd(add);
      });

      if (this.classList.contains('nsc-sc--slider') && this.list) this.initSlider();
    }

    stepWidth() {
      var item = this.list.querySelector('.nsc-sc__item');
      var style = window.getComputedStyle(this.list);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      return (item ? item.offsetWidth : 300) + gap;
    }

    scrollStep(direction) {
      if (!this.list) return;
      this.list.scrollBy({ left: direction * this.stepWidth(), behavior: 'smooth' });
    }

    initSlider() {
      var self = this;
      var list = this.list;

      function update() {
        if (self.prev) self.prev.disabled = list.scrollLeft <= 2;
        if (self.next) self.next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      }
      list.addEventListener('scroll', update, { passive: true });
      window.requestAnimationFrame(update);
      window.addEventListener('resize', update);

      var pressed = false;
      var dragging = false;
      var suppressClick = false;
      var startX = 0;
      var startLeft = 0;

      list.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, select')) return;
        pressed = true;
        dragging = false;
        startX = event.clientX;
        startLeft = list.scrollLeft;
      });

      list.addEventListener('pointermove', function (event) {
        if (!pressed) return;
        var delta = event.clientX - startX;
        if (!dragging && Math.abs(delta) > 5) {
          dragging = true;
          list.classList.add('is-dragging');
          list.style.scrollSnapType = 'none';
          list.setPointerCapture(event.pointerId);
        }
        if (dragging) list.scrollLeft = startLeft - delta;
      });

      function endDrag(event) {
        if (!pressed) return;
        pressed = false;
        if (!dragging) return;
        dragging = false;
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 0);
        list.classList.remove('is-dragging');
        try {
          list.releasePointerCapture(event.pointerId);
        } catch (error) {}
        var width = self.stepWidth();
        list.scrollTo({ left: Math.round(list.scrollLeft / width) * width, behavior: 'smooth' });
        window.setTimeout(function () { list.style.scrollSnapType = ''; }, 400);
      }
      list.addEventListener('pointerup', endDrag);
      list.addEventListener('pointercancel', endDrag);

      list.addEventListener('click', function (event) {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    }

    /* Ajout rapide : le produit part dans le panier coulissant */
    quickAdd(button) {
      if (button.classList.contains('is-loading')) return;
      var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      var cart = document.querySelector('cart-drawer');
      var canRender = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';
      var body = { id: variantId, quantity: 1 };
      if (canRender) {
        body.sections = cart.getSectionsToRender().map(function (section) { return section.id; }).join(',');
        body.sections_url = window.location.pathname;
      }

      var oldError = button.parentNode.querySelector('.nsc-sc__error');
      if (oldError) oldError.remove();
      button.classList.add('is-loading');

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            throw new Error(result.data.description || result.data.message || window.cartStrings.error);
          }
          if (canRender && result.data.sections) cart.renderContents(result.data);
          else window.location = window.routes.cart_url;
        })
        .catch(function (error) {
          var message = document.createElement('p');
          message.className = 'nsc-sc__error';
          message.setAttribute('role', 'alert');
          message.textContent = error.message;
          button.insertAdjacentElement('afterend', message);
        })
        .then(function () {
          button.classList.remove('is-loading');
        });
    }
  }

  customElements.define('nsc-showcase', NscShowcase);
})();
